import { Routes } from '@angular/router';
import { RouteUtils } from '../../../phito-core/src/lib/app/app/phito-routes';
import { ADMINISTRATION_ROUTES, USER_ROUTES } from '../../../phito-core/src/lib/modules/administration/administration.routes';
import { LOGIN_ROUTES } from '../../../phito-core/src/lib/modules/login/login.routes';
import { SCHULE_ROUTES } from './schule.routes';
import { TICKET_ROUTES } from '../../../phito-core/src/lib/modules/tickets/ticket.routes';

export const appRoutes: Routes = [
    ...RouteUtils.toRoutes(LOGIN_ROUTES),
    ...RouteUtils.toRoutes(SCHULE_ROUTES),
    ...RouteUtils.toRoutes({
        dbvariables: ADMINISTRATION_ROUTES.dbvariables,
        pushNotificationsConfig: ADMINISTRATION_ROUTES.pushNotificationsConfig,
        companies: ADMINISTRATION_ROUTES.companies,
        useractivities: ADMINISTRATION_ROUTES.useractivities
    }),
    ...RouteUtils.toRoutes({
        users: USER_ROUTES.users,
        usergroups: USER_ROUTES.usergroups,
        roles: USER_ROUTES.roles,
        userSessions: USER_ROUTES.userSessions,
        userSettings: USER_ROUTES.userSettings
    }),
    ...RouteUtils.toRoutes(TICKET_ROUTES),
    ...RouteUtils.defaultRoutes()
];
